import { useEffect, useState } from 'react';
import * as Location from 'expo-location';

const useLocation = () => {
  const [location, setLocation] = useState({
    loading: true,
    latitude: '',
    longitude: '',
    error: '',
  });

  useEffect(() => {
    (async () => {
      try {
        let isLocationGranted = true;
        const locationServiceAvailable =
          await Location.hasServicesEnabledAsync();
        if (!locationServiceAvailable) {
          isLocationGranted = false;
        }

        const { status, granted } =
          await Location.getForegroundPermissionsAsync();
        if (status !== 'granted' && !granted) {
          isLocationGranted = false;
          const { status: statusRequestPermission } =
            await Location.requestForegroundPermissionsAsync();
          if (statusRequestPermission == 'granted') {
            isLocationGranted = true;
          }
        }

        if (isLocationGranted) {
          const location = await Location.getCurrentPositionAsync({
            accuracy: Location.Accuracy.Highest,
            maximumAge: 10000,
          });
          if (location?.coords?.latitude && location?.coords?.longitude) {
            setLocation({
              loading: false,
              latitude: location.coords.latitude,
              longitude: location.coords.longitude,
            });
            return;
          }
        }

        setLocation({
          loading: false,
          latitude: '',
          longitude: '',
          error: '',
        });
      } catch (err) {
        setLocation({
          loading: false,
          latitude: '',
          longitude: '',
          error: err || 'Cannot access device location',
        });
        console.log('err-location', err);
      }
    })();
  }, []);

  return location;
};

export const getGeoCode = async (data) => {
  try {
    const location = await Location.reverseGeocodeAsync({
      latitude: data.latitude,
      longitude: data.longitude,
    });
    return location;
  } catch (error) {
    return null;
  }
};

export default useLocation;
